export default {
    'page': {
        component: import('@/components/integrations/protokol/minimax/Index'),
        permissions: ['read']
    },

    'home': {
        component: import('@/components/integrations/protokol/minimax/Home'),
        permissions: ['read']
    },

    'menu': {
        component: import('@/components/integrations/protokol/minimax/Menu'),
        permissions: ['read']
    },
}